<div class="row round-20 bg-blue">
  <div class="col-12 m-0 p-0">
    <div class="row float-content-center pt-2 font-bold font-18">
      <div class="col-5 float-content-start height-22 pt-3">
        <p>{{ ticket.DateCreated | date:'medium' }}</p>
      </div>
      <div class="col-2 float-content-center height-22 pt-3">
        <p>{{ ticket.Client }}</p>
      </div>
      <div class="col-4 float-content-end height-22 pt-3">
        <p>{{ ticket.Client_Name}}</p>
      </div>
      <div class="col-1 float-content-center pb-2 height-22 pt-3">
        <div class="pl-1 pr-1 pb-1 hover-color round-10" (click)="toggleTicket()">
          <i class="fa fa-angle-double-up font-22" *ngIf="showTicket"></i>
          <i class="fa fa-angle-double-down font-22" *ngIf="!showTicket"></i>
        </div>
      </div>
      <div class="col-12 float-content-start pt-3 height-22 pb-3">
        <p class="p-0 m-0">Last Update: {{ ticket.LastUpdated == null ? "" : ticket.LastUpdated | date:'medium' }}</p>
      </div>
    </div>
    <div class="row font-18">
      <div class="col-12 float-content-center">
        <p class="pl-0 ml-0">
          <a href="#" [routerLink]="['/tickets/'+  ticket.ID ]">
            #{{ ticket.ID }} {{ ticket.Subject }}
          </a>
        </p>
      </div>
    </div>
  </div>
  <div class="col-12 p-1" *ngIf="showTicket" [class.div-loading]="loading">
    <div class="row bg-lightblue ticket-details">
      <div class="col-10 p-2 pt-1 font-16">
        <div class="row">
          <div class="col-6 float-content-between">
            <p class="m-0 p-0">Submitted By:</p>
            <p class="m-0 p-0 pr-2">{{ ticket.Client_Name }}</p>
          </div>
          <div class="col-6 float-content-between bg-white">
            <p class="m-0 p-0">Opened:</p>
            <p class="m-0 p-0">{{ ticket.DateCreated | date: 'short' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 float-content-between bg-white">
            <p class="m-0 p-0">Client:</p>
            <p class="m-0 p-0">{{ ticket.Client }}</p>
          </div>
          <div class="col-6 float-content-between">
            <p class="m-0 p-0">Updated:</p>
            <p class="m-0 p-0 pr-2">{{ ticket.LastUpdated | date: 'short' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 float-content-between">
            <p class="m-0 p-0">Priority:</p>
            <p class="m-0 p-0 pr-2">{{ ticket.SupportTicketPriority }}</p>
          </div>
          <div class="col-6 float-content-between bg-white">
            <p class="m-0 p-0">Type:</p>
            <p class="m-0 p-0">{{ ticket.SupportTicketType }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 float-content-between bg-white">
            <p class="m-0 p-0">Status:</p>
            <p class="m-0 p-0 pr-2">{{ ticket.SupportTicketStatus }}</p>
          </div>
        </div>
        <div class="row mt-2">

          <div class="col-12 mt-2" *ngIf="ticket.ErrorMessage">
            <div class="row float-content-between align-content-start">
              <div class="col-3 pl-0">
                <p class="m-0 p-0 pr-2">Error&nbsp;Message:</p>
              </div>
              <div class="col-9 pr-0 mr-0 text-right">
                <span class="m-0 p-0">{{ ticket.ErrorMessage }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 mt-2" *ngIf="ticket.SystemUrl">
            <div class="row float-content-between align-content-start">
              <div class="col-3 pl-0">
                <p class="m-0 p-0 pr-2">URL:</p>
              </div>
              <div class="col-9 pr-0 mr-0 text-right text-wrap">
                <a [href]="ticket.SystemUrl">{{ ticket.SystemUrl }}</a>
              </div>
            </div>
          </div>
          <div class="col-12 mt-2">
            <p class="m-0 p-0 pr-2">Messages:</p>
          </div>
          <div class="col-12 mt-2">
            <div class="row">
              <div class="button-loading" *ngIf="!ticket.Messages">Loading</div>
              <div class="col-12 ticket-col-right mt-2 main-page-content-block" *ngIf="ticket.Messages">
                <div #messageContainer class="row mt-2 p-2 font-14 messages-container">
                  <div class="col-12 m-0 p-2 round-15" #messageRow *ngFor="let message of ticket.Messages">
                    <div class="row w-100"
                         [class.float-content-end]="message.IsMyMessage"
                         [class.float-content-start]="!message.IsMyMessage">
                      <div class="ticket-message-container col-10 pt-0 pb-2 m-0 pl-1 pr-1 round-15"
                           [class.bg-blue-38]="!message.IsAdmin && !message.AdminViewOnly"
                           [class.bg-blue]="message.IsAdmin && !message.AdminViewOnly && !message.IsMyMessage"
                           [class.bg-lightgreen]="message.IsAdmin && !message.AdminViewOnly && message.IsMyMessage"
                           [class.bg-lightpurple]="message.AdminViewOnly">
                        <div class="row w-100">
                          <div class="col-12 float-content-end" *ngIf="message.IsMyMessage == true">
                            <div class="message-options-button m-0 bg-lightblue round-10" (click)="showMessageMenu(message)">
                              <i class="fa fa-pencil-square-o m-0 p-2"></i>
                            </div>
                            <div class="message-menu-container round-15 bg-lightblue" *ngIf="selectedMessageID == message.ID">
                              <div class="float-content-start mb-1">
                                <p-checkbox type="checkbox"
                                            class=""
                                            name="closed"
                                            [binary]="true"
                                            [(ngModel)]="message.AdminViewOnly" (ngModelChange)="changeMessageAdminView(message)" id="ticket-closed-filter"></p-checkbox>
                                <label for="ticket-closed-filter" class="ml-1 font-14">Admin View Only</label>
                              </div>
                              <div class="message-menu-button mb-1" (click)="showEditMessage(message)">
                                Edit
                              </div>
                              <div class="message-menu-button bg-red" (click)="deleteMessage(message.ID)">
                                Delete
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 mt-2 pt-2">
                          <div class="row">
                            <div class="col-md-4 col-sm-12 m-0 p-0 mr-1 float-content-start font-14">
                              <span class="m-0 p-0">{{ message.User }}</span>
                            </div>
                            <div class="col-md-8 col-sm-12 m-0 p-0 float-content-dynamic-end font-14">
                              <span class="">{{ message.DateCreated | date:'medium' }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="ticket-file-thumbnail bg-white-hover m-1 p-2 col" role="button" *ngFor="let file of message.Attachments; let i = index" (click)="doShowAttachment(file)">
                            <div *ngIf="isImageAttachment(file)">
                              <img class="ticket-img-thumbnail" [src]="getAttachmentThumbnail(file)" />
                            </div>
                            <div *ngIf="!isImageAttachment(file)" class="ticket-file-icon-container float-content-center">
                              <i class="fa fa-file ticket-file-icon"></i>
                            </div>
                          </div>
                        </div>

                        <div class="col-12 mt-1 pl-3 pb-2 pt-2 bg-lightblue ticket-message" *ngIf="message.MessageHtml != null && message.ID == editingMessageID && doEdit == true">
                          <div class="row">
                            <ckeditor #editMessageEditor
                                      id="editMessage"
                                      name="newMessage"
                                      [editor]="Editor"
                                      [data]="message.MessageHtml"
                                      [config]="editorConfig"
                                      (change)="editMessageChange($event)"></ckeditor>
                          </div>
                          <div class="row">
                            <div class="col-12 m-0 p-0 float-content-end">
                              <div class="ticket-view-btn bg-white-hover text-center" (click)="cancelEdit(message)">
                                <span class="m-0 p-0">Cancel</span>
                              </div>
                              <div class="ticket-view-btn bg-blue-38 text-center" (click)="doEditMessage(message)">
                                <span class="m-0 p-0">Update</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 mt-1 pl-3 pb-2 pt-2 bg-lightblue ticket-message" *ngIf="message.MessageHtml == null && message.Message != null && message.ID == selectedMessageID && doEdit == true">
                          <div class="row">
                            <ckeditor #editMessageEditor
                                      id="editMessage"
                                      name="newMessage"
                                      [editor]="Editor"
                                      [data]="message.Message"
                                      [config]="editorConfig"
                                      (change)="editMessageChange($event)"></ckeditor>
                          </div>
                          <div class="row">
                            <div class="col-12 m-0 p-0 float-content-end">
                              <div class="ticket-view-btn bg-blue-38 text-center" (click)="doEditMessage(message)">
                                <span class="m-0 p-0">Update</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 mt-1 pl-3 pb-2 pt-2 bg-lightblue ticket-message" *ngIf="(doEdit == false || editingMessageID != message.ID) && message.MessageHtml == null && editingMessageID != message.ID">
                          <div class="w-100">
                            <span class="m-0 p-0">{{ message.Message }}</span>
                          </div>
                        </div>
                        <div class="col-12 mt-1 pl-3 pb-0 pt-2 bg-lightblue ticket-message" *ngIf="(doEdit == false || editingMessageID != message.ID) && message.MessageHtml != null">
                          <div class="w-100" [innerHTML]="message.MessageHtml">
                          </div>
                        </div>
                        <div class="col-12 text-end pt-0 mt-0" *ngIf="message.AdminViewOnly">(Admin View Only)</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 new-message-container bg-lightblue round-15">
                    <div class="row w-100 mb-2 mt-3">
                      <div class="col-12">
                        <ckeditor #newMessageEditor
                                  id="newMessage"
                                  name="newMessage"
                                  [editor]="Editor"
                                  [data]="initialNewMessage"
                                  [config]="editorConfig"
                                  (change)="editorOnChange($event)"></ckeditor>
                      </div>
                      <div class="col-8 float-content-start mt-3">
                        <div class="mb-1 ml-1 float-content-start">
                          <p-checkbox type="checkbox"
                                      class=""
                                      name="isAdminViewOnly"
                                      [binary]="true"
                                      [(ngModel)]="adminViewOnly" id="isAdminViewOnly"></p-checkbox>
                          <label for="isAdminViewOnly" class="ml-1 font-18">Admin View Only</label>
                        </div>
                      </div>
                      <div class="col-4 float-content-end mt-3">
                        <div class="message-btn bg-blue-38 text-center" (click)="sendNewMessage()">
                          <span class="m-0 p-0 font-22">Send</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2 ticket-buttons h-100">
        <div class="ticket-btn bg-blue-38 text-center" (click)="openMoreInfo()">
          <span class="m-0 p-0">More Info</span>
        </div>
        <div class="ticket-btn bg-blue-38 text-center" (click)="doPinTicket()">
          <span class="m-0 p-0">{{ ticket.IsPinnedByUser == true ? "Unpin" : "Pin" }}</span>
        </div>
        <div *ngIf="ticket.GitHub_IssueNumber == null || ticket.GitHub_IssueNumber == 0">
          <div class="ticket-btn bg-blue-38 text-center" (click)="showLinkGitHub()">
            <span class="m-0 p-0">Send To Github</span>
          </div>
        </div>
        <div *ngIf="ticket.GitHub_IssueNumber != null && ticket.GitHub_IssueNumber != 0">
          <div class="ticket-btn bg-blue-38 text-center" (click)="openGitHubLink()">
            <span class="m-0 p-0">Open In Github</span>
          </div>
        </div>
        <div class="ticket-close-btn bg-red text-center" *ngIf="ticket.DateClosed == null" (click)="doSetClosed()">
          <span class="m-0 p-0">Close</span>
        </div>
        <div class="ticket-restore-btn bg-lightgreen text-center" *ngIf="ticket.DateClosed != null" (click)="doSetClosed()">
          <span class="m-0 p-0">Restore</span>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Link GitHub Issue" [modal]="true" [(visible)]="gitHubIssueVisible">
  <div class="row">
    <div class="col mb-3">
      <label for="gitHubIssue">Issue</label><br />
      <select id="gitHubIssue" [(ngModel)]="gitHubIssue" [class.div-loading]="loadingGitHubIssue" class="form-control">
        <option *ngFor="let issue of gitHubIssues" [ngValue]="issue">
          {{issue.repository}} -  {{issue.number}} -  {{issue.title}}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col mb-3">
      <label for="gitHubComment">Comment</label><br />
      <input type="text" id="gitHubComment" [(ngModel)]="gitHubComment" class="form-control" />
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnGithubConfirm" [class.button-loading]="loading" (click)="linkGitHub()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnGithubCancel" [class.button-loading]="loading" (click)="gitHubIssueVisible=false">Cancel</button>
    </div>
  </div>
</p-dialog>
<p-dialog header="Support Ticket File" [modal]="true" [(visible)]="attachmentModalVisible" [style]="{ width: 'fit-content', 'max-width': '90vw' }">
  <div class="row">
    <div class="col mb-3">
      <div *ngIf="modalIsImageAttachment() && loadingAttachment" class="float-right button-loading font-22">&nbsp;</div>
      <h5 class="content-heading-font">{{ selectedAttachmentName }}</h5>
    </div>
  </div>
  <div class="row main-page-content-block float-content-center border">
    <div *ngIf="modalIsImageAttachment()">
      <a [href]="getModalAttachmentImage()" target="_blank">
        <img [src]="getModalAttachmentImage()" class="ticket-img-lg" />
      </a>
    </div>
    <div *ngIf="!modalIsImageAttachment() && selectedFile" class="ticket-file-icon-container float-content-center" (click)="doDownloadAttachment()">
      <i class="fa fa-file font-22 mr-3"></i>
      <span>{{selectedFile.FileSize }}Kb</span>
      <button class="btn" role="button">
        <i class="fa fa-cloud-download"></i>
      </button>
    </div>
  </div>
  <div class="row mt-3 pt-2">
    <div class="col text-center">
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnAttachmentClose" (click)="attachmentModalVisible=false">Cancel</button>
    </div>
  </div>
</p-dialog>
